import { render } from "./PreselectTabs.vue?vue&type=template&id=5e23a255&scoped=true"
import script from "./PreselectTabs.vue?vue&type=script&lang=js"
export * from "./PreselectTabs.vue?vue&type=script&lang=js"

import "./PreselectTabs.vue?vue&type=style&index=0&id=5e23a255&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e23a255"]])

export default __exports__